import React, { useEffect, useRef } from "react";
import { Button } from "./ui/button";

export default function ApplicationError() {
  const title = useRef(null);
  useEffect(() => { title.current?.focus(); }, []);

  return (
    <main className="flex min-h-screen items-center justify-center bg-background p-6">
      <section className="w-full max-w-lg rounded-xl border border-border bg-card p-6 sm:p-8" aria-labelledby="application-error-title">
        <h1 ref={title} tabIndex={-1} id="application-error-title" className="font-heading text-2xl font-bold">
          Impossibile mostrare la pagina
        </h1>
        <p role="alert" className="mt-3 text-muted-foreground">
          Si è verificato un problema di visualizzazione. Ricarica la pagina per riprovare.
        </p>
        <p className="mt-3 text-sm text-muted-foreground">
          La sessione e le bozze già salvate non vengono cancellate. Le modifiche non ancora salvate potrebbero dover essere reinserite.
        </p>
        <div className="mt-6 flex flex-wrap items-center gap-4">
          <Button type="button" className="min-h-11" onClick={() => window.location.reload()}>
            <span>Ricarica la pagina</span>
          </Button>
          <Button asChild variant="outline" className="min-h-11">
            <a href="/"><span>Torna alla pagina iniziale</span></a>
          </Button>
        </div>
      </section>
    </main>
  );
}
